import store from "../redux/store";
import { captureException } from "../sentry";
import { genderConstants, sexConstants } from "../sexAndGender";

export const isMaleGender = (state = store.getState()) =>
  !state.surveyAnswers.gender ||
  state.surveyAnswers.gender[0] === genderConstants.male;

export const isFemaleGender = (state = store.getState()) =>
  !state.surveyAnswers.gender ||
  state.surveyAnswers.gender[0] === genderConstants.female;

export const isMaleSex = (state = store.getState()) =>
  !state.surveyAnswers.sex || state.surveyAnswers.sex[0] === sexConstants.male;

export const isOver30DaySubscriber = (state = store.getState()) => {
  try {
    const { subscriptions, subscription_id } = state.serverContext;
    const subscriptionsArr = JSON.parse(subscriptions);
    const subscription = subscriptionsArr.find((s) => s.id === subscription_id);

    const startDate = new Date(
      subscription.time_started.year,
      subscription.time_started.month - 1 /* months are from 0 to 11 */,
      subscription.time_started.day
    );

    const currentDate = new Date();
    const timeDifference = currentDate.getTime() - startDate.getTime();

    const daysDifference = timeDifference / (1000 * 3600 * 24);

    return daysDifference >= 30;
  } catch (e) {
    captureException(e, "isOver30DaySubscriber");
    return false;
  }
};
